module.exports = __webpack_public_path__ + "static/media/Avatars_Female-06.716c867a.png";